<template>
  <div
    v-if="!lpu.closed && lpuAddress && (lpuAddress.schedule_status || lpuAddress.schedule_str)"
    class="work-schedule"
  >
    <v-menu
      v-if="!isMobile"
      v-model="isOpen"
      attach=""
      class="work-schedule__menu"
      content-class="work-schedule__menu-content"
      min-width="301"
      max-width="301"
      nudge-bottom="12"
      z-index="110"
      :allow-overflow="false"
      :close-on-content-click="false"
      open-on-hover
      :open-on-click="false"
      :open-on-focus="false"
      offset-y
    >
      <template #activator="{ attrs, on }">
        <InfoCard
          v-bind="attrs"
          data-qa="lpu_work_schedule"
          class="cursor-pointer h-100"
          icon="ui-icon-filled-clock"
          :title="`${tStatic('Режим работы')}:`"
          use-hover
          v-on="on"
        >
          <template
            v-if="lpuAddress.schedule_status"
            #subtitle
          >
            {{ tDynamic(lpuAddress, 'schedule_status') }}
          </template>
          <template
            v-else
            #subtitle
          >
            <span
              v-html="tDynamic(lpuAddress, 'schedule_str').toUpperCase()/* eslint-disable-line vue/no-v-html */"
            />
          </template>
        </InfoCard>
      </template>

      <WorkSchedulePanel
        :schedule="schedule"
        :is-loading="isLoading"
      />
    </v-menu>

    <template v-else>
      <InfoCard
        data-qa="lpu_work_schedule"
        class="cursor-pointer"
        icon="ui-icon-filled-clock"
        :title="`${tStatic('Режим работы')}:`"
        @click="isOpen = true"
      >
        <template
          v-if="lpuAddress.schedule_status"
          #subtitle
        >
          {{ tDynamic(lpuAddress, 'schedule_status') }}
        </template>
        <template
          v-else
          #subtitle
        >
          <span
            v-html="tDynamic(lpuAddress, 'schedule_str').toUpperCase()/* eslint-disable-line vue/no-v-html */"
          />
        </template>
      </InfoCard>

      <v-bottom-sheet v-model="isOpen">
        <v-sheet class="pa-4">
          <div class="mb-6">
            <div class="text-h6 text--text mb-4">
              {{ tStatic('График работы') }}
            </div>
            <WorkSchedulePanel
              :schedule="schedule"
              :is-loading="isLoading"
            />
          </div>
          <v-btn
            block
            depressed
            color="primary"
            class="branding-btn branding-btn--primary"
            data-qa="lpu_work_schedule_close"
            @click="isOpen = false"
          >
            {{ tStatic('Понятно') }}
          </v-btn>
        </v-sheet>
      </v-bottom-sheet>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import tDynamic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tDynamic'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import apiLpuSchedule from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/WorkSchedule/api/apiLpuSchedule'
import type { LpuScheduleResponse } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/WorkSchedule/api/apiLpuSchedule.types'
import InfoCard from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/InfoCard.vue'
import WorkSchedulePanel from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/WorkSchedule/components/WorkSchedulePanel.vue'

const props = defineProps<{
  lpu: Lpu
}>()

const lpuAddress = computed(() => props.lpu.addr[0])
const isMobile = useIsMobile()

const isOpen = ref(false)
const schedule = ref<LpuScheduleResponse | null>(null)
const isLoading = ref(false)
const isRequestFailed = ref(false)

async function loadSchedule() {
  const addressId = lpuAddress.value?.id

  if (!addressId || schedule.value || isLoading.value || isRequestFailed.value) {
    return
  }

  isLoading.value = true

  try {
    const { data } = await apiLpuSchedule.get(addressId)

    // eslint-disable-next-line require-atomic-updates
    schedule.value = data
  } catch {
    // eslint-disable-next-line require-atomic-updates
    isRequestFailed.value = true
  } finally {
    // eslint-disable-next-line require-atomic-updates
    isLoading.value = false
  }
}

watch(isOpen, isOpened => {
  if (isOpened) {
    loadSchedule()
  }
})
</script>

<style lang="scss" scoped>
@import 'src/styles/variables';

.work-schedule {
  position: relative;
}
</style>

<style lang="scss">
@import 'src/styles/variables';

.work-schedule__menu-content {
  box-shadow: 0 2px 24px 0 rgba(9, 42, 72, 0.08),
    0 0 2px 0 rgba(21, 40, 92, 0.06),
    0 1px 2px 0 rgba(5, 23, 40, 0.08) !important;
  background-color: $ui-kit-bg-gray-0 !important;
  border-radius: $border-radius-xl !important;
  padding: 24px !important;
  width: 301px !important;
  min-width: 301px !important;
  max-width: 301px !important;
  overflow: hidden;
}
</style>
